import { render, staticRenderFns } from "./ExtraValueField.vue?vue&type=template&id=26b06d4e&scoped=true"
import script from "./ExtraValueField.vue?vue&type=script&lang=ts"
export * from "./ExtraValueField.vue?vue&type=script&lang=ts"
import style0 from "./ExtraValueField.vue?vue&type=style&index=0&id=26b06d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b06d4e",
  null
  
)

export default component.exports